<style>
    input {
        min-width: 60%;
    }

    .section {
        margin-bottom: 20px;
    }

    .social-media-button {
        display: inline-block;
    }

    img {
        cursor: pointer;
    }

    .notice {
        background-color: #dfb8fd;
        border-radius: 10px;
        padding: 10px;
        margin-bottom: 30px;
        margin-top: 0px;
    }

</style>


<script>
    import * as Common from '../Common.js';

    export let link = ''
    export let shareString = ''
    export let showMessage = false
    let linkBox;

    function shareOnFB(){
    var url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(link)
    window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
    hideWidget()
}

    function shareOntwitter(){
        var url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(link) + '&text=' + encodeURIComponent(shareString)
        TwitterWindow = window.open(url, 'TwitterWindow','width=600,height=300')
        hideWidget()
    }

    function copyToClipboard() {
        linkBox.select();
        document.execCommand('copy')
        Common.CreateNotification({body: "Link Copied!"}, 500)
    }
</script>

{#if showMessage}
    <div style="margin-bottom: 20px;">
        <h2>Thank you for your contribution!</h2>
        <p>
            Please consider sharing your new item! This helps spread awareness and allows more people to empower themselves by using Plan Together.
        </p>
    </div>
{/if}

<div class="section">
    <b>Sharable Link</b><br>
    <p>
        <i>This URL will allow others to easily access this content.</i>
    </p>
    <input bind:this={linkBox} value={link}><div class="control-single" style="margin-left: 5px" on:click={copyToClipboard}>Copy Link</div>
</div>
<div class="section">
    <b>Social Media</b><br>
    <p>
        <i>Share to your social networks.</i>
    </p>
    <img src="/facebook_btn.png" on:click={shareOnFB}>
    <img src="/twitter_btn.png" on:click={shareOntwitter}>
</div>